export const ACTION = {
  name: 'HOME'
};
